import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { patientDateOfServiceConstant } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_PATIENT_DATE_OF_SERVICE_FAILURE,
  GET_PATIENT_DATE_OF_SERVICE_SUCCESS,
  GET_PATIENT_DATE_OF_SERVICE_REQUEST,
} = patientDateOfServiceConstant;

function* getDateOfService(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(therapyPlanningService.getDateOfService, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_PATIENT_DATE_OF_SERVICE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PATIENT_DATE_OF_SERVICE_FAILURE, payload: error });
  }
}

function* getDataOfServiceSaga() {
  yield takeEvery(GET_PATIENT_DATE_OF_SERVICE_REQUEST, getDateOfService);
}

export default getDataOfServiceSaga;
